import React from 'react';
import { Grid } from '@chakra-ui/react';
import PartnerCard, { PartnerProps } from './PartnerCard';

interface PartnerCardGridProps {
  partnerCardItems: PartnerProps[];
}

const PartnerCardGrid = ({ partnerCardItems = [] }: PartnerCardGridProps) => (
  <Grid
    templateColumns="repeat(auto-fill, minmax(200px, 1fr))"
    gap={4}
    px={[8, 20]}
    mx="auto"
    maxW="7xl"
  >
    {partnerCardItems.map(({ name, image, url }) => (
      <PartnerCard key={name} name={name} image={image} url={url} />
    ))}
  </Grid>
);

export default PartnerCardGrid;
